import { useQuery } from "@tanstack/react-query";
import { getQueryTextByHash } from "@/helpers/apis";
import { RelativeComponentLoader } from "@/components/loader";
import { CodeDiff2Editor } from "@/components/codeEditor";
import { RunCompareDiff } from "./types";

const CompareAccordionContent = ({ item }: { item: RunCompareDiff }) => {
  const run1Query = useQuery({
    queryKey: ["query_text", item.run1.query_hash],
    queryFn: () => getQueryTextByHash(item.run1.query_hash!),
    enabled: Boolean(item.run1.query_hash),
  });
  const run2Query = useQuery({
    queryKey: ["query_text", item.run2.query_hash],
    queryFn: () => getQueryTextByHash(item.run2.query_hash!),
    enabled: Boolean(item.run2.query_hash),
  });
  if (run1Query.isLoading || run2Query.isLoading) {
    return <RelativeComponentLoader label="Loading..." />;
  }
  return (
    <CodeDiff2Editor
      editor1Value={run1Query.data?.query_text ?? ""}
      editor2Value={run2Query.data?.query_text ?? ""}
      language="sql"
      readOnly
    />
  );
};

export default CompareAccordionContent;
